import { createContext, useContext, useEffect, useState } from "react";
import { en, tr } from "../data/translations";

const dictionaries = { en, tr };
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("mvalog-lang") || "en");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("mvalog-lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang === "tr" ? "tr" : "en";
  }, [lang]);

  return <LanguageContext.Provider value={{ lang, setLang, t: dictionaries[lang] }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
